import React, { useState } from 'react'
import TextAreaWithLink from './TextAreaWithLink'
import UpdatePersonExtendedInfo from '../../../Services/Mutations/UpdatePersonExtendedInfo'
import { toast } from 'react-toastify'
import { ToastStyle } from '../../Data/MovieStaticData'
import { Auth } from 'aws-amplify'
import { capitalizeFirstLetter } from './CapitalizeFirstLetter'
import { FaCaretDown, FaCaretUp } from 'react-icons/fa'
import SocialMediaLinks from './SocialMedia'
import PerformanceVideos from './PerformanceVideos'

function FavouritesAndCarrers(props) {
  const {
    activeSection,
    handleSectionClick,
    personalAndBackGroundInfo,
    setPersonalAndBackGroundInfo,
    section,
    getUpdatedData,
    personData,
    label,
    setLoader,
  } = props
  const [changesMade, setChangesMade] = useState(false)
  let loggedInUserHandle = ''
  const loggedInUserEmail = Auth.user.attributes ? Auth.user.attributes.email : ''
  if (loggedInUserEmail) {
    const emailParams = loggedInUserEmail.split('@')
    loggedInUserHandle = '@' + emailParams[0]
  }

  const handleTextAreaChange = (newValue, index) => {
    const updatedInfo = [...personalAndBackGroundInfo]
    updatedInfo[index].answer_En = Array.isArray(newValue[0]) ? newValue[0] : [newValue[0]]
    updatedInfo[index].answer_Te = Array.isArray(newValue[1]) ? newValue[1] : [newValue[1]]
    setPersonalAndBackGroundInfo(updatedInfo)
    setChangesMade(true)
  }

  const savePersonalAndBackGroundInfo = async () => {
    setLoader(true)

    // Check if personalAndBackGroundInfo is an array and contains elements
    if (!Array.isArray(personalAndBackGroundInfo) || personalAndBackGroundInfo.length === 0) {
      // If personalAndBackGroundInfo is not a non-empty array, log an error and return
      console.error('personalAndBackGroundInfo is not a non-empty array.')
      return
    }

    const input = {
      PK: personData.PK,
      SK: personData.SK,
      moderatorID: Auth.user.username,
      moderatorHandle: loggedInUserHandle,
    }

    const labelInput = {}

    // Iterate over each item in personalAndBackGroundInfo
    personalAndBackGroundInfo.forEach(item => {
      // Check if item and item.field_En exist
      if ((item && item.field_En) || (item && item.field_Te)) {
        // Check if the field is 'socialMediaLinks' and it has answerItems
        if (item.field_En === 'socialMediaLinks' && item.answerItems_En && item.answerItems_En[0]) {
          const socialMediaLinks = item.answerItems_En[0]

          // Loop through the properties of socialMediaLinks
          for (const key in socialMediaLinks) {
            // Check if the property is owned by socialMediaLinks
            if (Object.prototype.hasOwnProperty.call(socialMediaLinks, key)) {
              // Assign the value to labelInput with the key
              labelInput[key] = socialMediaLinks[key]
            }
          }
        } else if (
          (item.field_En === 'standoutStagePerformanceVideos' ||
            item.field_En === 'popularDialogueVideos') &&
          Array.isArray(item.answerItems_En)
          // item.answerItems_En.toString()
        ) {
          labelInput[item.field_En] = item.answerItems_En.map(({ __typename, ...rest }) => rest)
        } else {
          // For other fields, assign the English and Telugu answers to labelInput
          if (item.answer_En && item.answer_En.toString()) {
            labelInput[item.field_En] = item.answer_En
          }

          if (item.field_Te && item.answer_Te && item.answer_Te.toString()) {
            labelInput[item.field_Te] = item.answer_Te
          }
        }
      }
    })

    // Add the label input data to the input object
    const inputkey = '__typename'
    if (labelInput[inputkey] !== undefined) {
      delete labelInput[inputkey]
    }

    input[label] = labelInput

    try {
      // Call the UpdatePersonExtendedInfo mutation with the input data
      const update = await UpdatePersonExtendedInfo(input)
      if (update.statusCode === '200') {
        // If successful, display success message and update state
        toast.success(`${update.statusMessage}`, ToastStyle)
        setChangesMade(false)
        setLoader(false)
        getUpdatedData()
      } else {
        // If update failed, display error message
        toast.error('Failed to update. Please try again.')
        setLoader(false)
      }
    } catch (error) {
      setLoader(false)
      // Catch any errors that occur during the update process and log them
      console.error('Error in SubmitExtendedInfo:', error.message)
    }
  }

  return (
    <div id={section} className={`accordion-item ${activeSection === section ? 'active' : ''}`}>
      {/* Accordion header */}
      <h2 className='accordion-header' id='headingThree'>
        {/* Button to toggle the accordion */}
        <button
          className='accordion-button'
          type='button'
          data-bs-toggle='collapse'
          data-bs-target='#collapseThree'
          aria-expanded={activeSection === section || activeSection === 'all'}
          aria-controls='collapseThree'
          onClick={() => handleSectionClick(section)}
          style={{ color: 'white' }}
        >
          {/* Display the label with the first letter capitalized */}
          <span>{capitalizeFirstLetter(label)}</span>
          {/* Display the caret icon based on the accordion state */}
          {activeSection === section || activeSection === 'all' ? <FaCaretUp /> : <FaCaretDown />}
        </button>
      </h2>
      {/* Accordion content */}
      <div
        id='collapseThree'
        className={`accordion-collapse collapse ${
          activeSection === section || activeSection === 'all' ? 'show' : ''
        }`}
        aria-labelledby='headingThree'
        data-bs-parent='#accordion'
      >
        {/* Map through personalAndBackGroundInfo to render TextAreaWithLink components */}
        {personalAndBackGroundInfo.map((info, index) => (
          <>
            {info && info.field_En && info.field_En === 'socialMediaLinks' ? (
              <SocialMediaLinks
                key={index}
                index={index}
                labels={[info.field_En]}
                data={info.answerItems_En ? info.answerItems_En[0] : ''}
                question={info.question_En}
                setPersonalAndBackGroundInfo={setPersonalAndBackGroundInfo}
                personalAndBackGroundInfo={personalAndBackGroundInfo}
                setChangesMade={setChangesMade}
              />
            ) : (info && info.field_En && info.field_En === 'standoutStagePerformanceVideos') ||
              (info && info.field_En && info.field_En === 'popularDialogueVideos') ? (
              <PerformanceVideos
                index={index}
                question={info.question_En}
                GalleryVideos={info.answerItems_En || []}
                setPersonalAndBackGroundInfo={setPersonalAndBackGroundInfo}
                personalAndBackGroundInfo={personalAndBackGroundInfo}
                setChangesMade={setChangesMade}
                // inputData={inputData}
                // sendinputdata={sendinputdata}
              />
            ) : (
              <TextAreaWithLink
                key={index}
                labels={[info.field_En, info.field_Te]}
                placeholders={[info.question_En, info.question_Te]}
                value={[info.answer_En || '', info.answer_Te || '']}
                onChange={newValue => handleTextAreaChange(newValue, index)}
                setChangesMade={setChangesMade}
              />
            )}
          </>
        ))}
        {/* Save and Cancel buttons */}
        <div
          className='d-flex'
          style={{ justifyContent: 'center', alignItems: 'center', gap: '5px', marginTop: '5px' }}
        >
          {/* Save button */}
          <button
            className='btn btn-success'
            onClick={() => {
              setChangesMade(false)
              savePersonalAndBackGroundInfo()
            }}
            disabled={!changesMade} // Disable if no changes made
          >
            save
          </button>
          {/* Cancel button */}
          <button
            className='btn btn-secondary'
            onClick={() => {
              setChangesMade(false) // Reset changesMade state
              getUpdatedData() // Call function to get updated data
            }}
            disabled={!changesMade} // Disable if no changes made
          >
            cancel
          </button>
        </div>
      </div>
    </div>
  )
}

export default FavouritesAndCarrers
